import { useEffect } from 'react';
import { useSetPerformanceMode, usePerformanceMode } from '../store/uiStore';

/**
 * Hook to automatically detect low-end devices and enable Lite Mode.
 * Targets: Android 10, < 2GB RAM, slow CPU.
 */
export const usePerformanceDetection = () => {
  const setPerformanceMode = useSetPerformanceMode();
  const isPerformanceModeSetManually = usePerformanceMode();

  useEffect(() => {
    // Si l'utilisateur a déjà activé le mode manuellement (persisté), on ne le force pas
    // Sauf si on veut forcer l'auto-détection au premier chargement.
    
    const detectLowEnd = () => {
      // 1. Détection de la RAM (disponible sur Chrome/Android)
      // navigator.deviceMemory renvoie la RAM en Go (arrondi)
      const ram = (navigator as any).deviceMemory;
      
      // 2. Détection du CPU (nombre de cœurs)
      const cores = navigator.hardwareConcurrency;
      
      // 3. Détection de la connexion
      const connection = (navigator as any).connection;
      const isSlowConn = connection && (connection.effectiveType === '2g' || connection.effectiveType === 'slow-2g');

      // 4. Détection User Agent pour Android 10 ou moins
      const ua = navigator.userAgent;
      const isOldAndroid = /Android [1-9]\.|Android 10\./i.test(ua);

      const criteria = {
        lowRam: ram && ram <= 2,
        lowCpu: cores && cores <= 4,
        slowConn: isSlowConn,
        oldAndroid: isOldAndroid
      };

      if (criteria.lowRam || criteria.lowCpu || criteria.slowConn || criteria.oldAndroid) {
          console.log('[EKOSE] Low-end device detected, enabling Lite Mode automatically.', criteria);
          setPerformanceMode(true);
      }
    };

    // On ne lance la détection que si le mode n'est pas déjà actif
    if (!isPerformanceModeSetManually) {
        detectLowEnd();
    }
  }, [setPerformanceMode, isPerformanceModeSetManually]);
};
